// removed by extract-text-webpack-plugin
module.exports = {"fullWidth":"f4_f5","description":"f4_o"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/Discover/styles.module.css
// module id = 1227
// module chunks = 27